var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fab-cell" },
    [
      _c("div", { staticClass: "fab-cell-text" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { fab: "", small: "", color: "#ffffff" },
          on: {
            click: function($event) {
              return _vm.$emit("fabOptionClicked")
            }
          }
        },
        [
          _c("v-icon", { attrs: { color: "#404040" } }, [
            _vm._v(_vm._s(_vm.image))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }